import styled from 'styled-components'
import { colors, media } from 'client/styles'
import { InformationBoxBase } from 'src/comps/InformationBox/styles'

export const ButtonWrapper = styled.div`
  padding-block: 20px;
  padding-inline: 20px;
  position: fixed;
  inset-block-end: 0;
`

export const ConfirmOfferBase = styled.div`
  width: 100%;
  min-height: 700px;
  background-color: #fff;
  overflow-y: hidden;
  height: auto;

  ${InformationBoxBase} {
    margin-inline: 0;
    margin-block: 20px;
  }

  ${media.tablet} {
    padding-block-start: 0;
    min-height: 0;
    height: calc(80vh);
    overflow-y: scroll;
  }

  ${ButtonWrapper} {
    position: fixed;
    background-color: ${colors.white};
    padding-block: 10px;
    padding-inline: 20px;
    inset-block-end: 0;
    width: 100%;
    border-block-start: 1px solid ${colors.grey4};

    ${media.tablet} {
      position: unset;
      padding-block: 20px;
      padding-inline: 20px;
      border-end-start-radius: 8px;
      border-end-end-radius: 8px;
    }
  }
`

export const Content = styled.div`
  padding-block: 0;
  padding-inline: 20px;
  padding-bottom: 70px;

  ${media.tablet} {
    padding-bottom: 0;
  }
`

export const Row = styled.div`
  display: flex;
  width: 100%;

  padding-block: 15px;
  padding-inline: 0;
`

export const Title = styled(Row)`
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  color: ${colors.grey1};

  padding-block: 0 16px;
  padding-inline: 0;
`

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: var(--border-size-2) solid var(--color-neutral-400);
  border-radius: var(--radius-8);

  & > div {
    border-width: 0;
  }

  & > section {
    padding: var(--space-16);
  }

  ${media.tablet} {
    flex-direction: row;
  }
`
